module.exports = __webpack_public_path__ + "img/fashion_06.8c24491f.jpg";